import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SwiperModule } from 'swiper/angular';
import { PipesModule } from '../pipes/pipes.module';
import { InitGeoComply } from './init-geocomply/init-geocomply';
import { CustomNavbarComponent } from './lobby/custom-navbar/custom-navbar.component';
import { GameModule } from './game/game.module';
import { GamblingProblemComponent } from './gambling-problem/gambling-problem.component';
import { ContactSupportComponent } from './contact-support/contact-support.component';
import { SuccessMessageComponent } from './success-message/success-message.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { NoteBoxComponent } from './note-box/note-box.component';
import { DepositButtonComponent } from './cashier/deposit-button/deposit-button.component';
import { DepositAllMethodsComponent } from './cashier/deposit-all-methods/deposit-all-methods.component';
import { DepositBonusOffersComponent } from './cashier/deposit-bonus-offers/deposit-bonus-offers.component';
import { DepositLimitComponent } from './cashier/deposit-limit/deposit-limit.component';
import { SidemenuComponent } from './menu/sidemenu';
import { BalanceComponent } from './balance/balance.component';
import { AppInitComponent } from './app-init/app-init.component';
import { ServerNotificationComponent } from './../../app/pages/server-notification/server-notification.component';
import { InactivityComponent } from './../../app/pages/inactivity/inactivity.component';
import { DepositLogoComponent } from './cashier/deposit-logo/deposit-logo.component';
import { DepositDefaultAmountsComponent } from './cashier/deposit-default-amounts/deposit-default-amounts.component';
import { LastPlayedGamesModule } from './last-played-games/last-played-games.module';
import { BannerSliderComponent } from './banner-slider/banner-slider.component';

import { TransactionListComponent } from './transaction-list/transaction-list.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SiteHeaderComponent } from './site-header/site-header.component';
import { WebcontentComponent } from './webcontent/webcontent.component';
import { FooterModule } from './footer/footer.module';
import { RedirectComponent } from './redirect/redirect.component';
import { SizingComponent } from './mobile/sizing/sizing.component';
import { GameAutomationComponent } from './game-automation/game-automation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavigationTabsComponent } from './navigation-tabs/navigation-tabs.component';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { CalendarComponent } from './calendar/calendar.component';
import { BonusSelectorComponent } from './bonus-selector/bonus-selector.component';
import { MobileModule } from './mobile/mobile.module';
import { directivesModule } from '../directives/directives.module';
import { LimitsTableRowComponent } from './limits-table-row/limits-table-row.component';
import { ProgressingComponent } from './progressing/progressing.component';
import { ValidatePinComponent } from './validate-pin/validate-pin.component';
import { GamesBonusFreeSpinsComponent } from './games-bonus-free-spins/games-bonus-free-spins.component';
import { SiteLogoComponent } from './lobby/site-logo/site-logo.component';
import { HeaderTabsComponent } from './lobby/header-tabs/header-tabs.component';
import { LoyaltyProgramProvider } from '../services/loyalty-program/loyalty-program.service';
import { LoyaltyProgramPage } from '../pages/loyalty-program/loyalty-program';
import { CDNIconComponent } from './icon/cdn-icon.component';
import { SidemenuTabsComponent } from './menu/sidemenu-tabs/sidemenu-tabs.component';
import { DateETPipe } from '../pipes/date-format-et.pipe';
import { DateTimestampFormatPipe } from '../pipes/date-timestamp-format.pipe';
import { DateFormatPipe } from '../pipes/date-format.pipe';
import { ThrottleClickDirective } from '../directives/throttle-click/throttle-click.directive';
import { ThrottleSubmitDirective } from '../directives/throttle-submit/throttle-submit.directive';
import { LeftSidemenuComponent } from './left-sidemenu/left-sidemenu';
import { WebKeyboardListenerComponent } from './web-keyboard-listener/web-keyboard-listener.component';
@NgModule({
  declarations: [
    AppInitComponent,
    BalanceComponent,
    BannerSliderComponent,
    BonusSelectorComponent,
    CalendarComponent,
    ContactSupportComponent,
    CustomNavbarComponent,
    DateTimePickerComponent,
    DepositAllMethodsComponent,
    DepositBonusOffersComponent,
    DepositButtonComponent,
    DepositDefaultAmountsComponent,
    DepositLimitComponent,
    DepositLogoComponent,
    LoyaltyProgramPage,
    ErrorMessageComponent,
    GamblingProblemComponent,
    GameAutomationComponent,
    InactivityComponent,
    InitGeoComply,
    LimitsTableRowComponent,
    NavigationTabsComponent,
    NoteBoxComponent,
    ProgressingComponent,
    RedirectComponent,
    ServerNotificationComponent,
    SidemenuComponent,
    LeftSidemenuComponent,
    SiteHeaderComponent,
    SiteLogoComponent,
    SizingComponent,
    SuccessMessageComponent,
    TransactionListComponent,
    ValidatePinComponent,
    WebcontentComponent,
    GamesBonusFreeSpinsComponent,
    HeaderTabsComponent,
    CDNIconComponent,
    SidemenuTabsComponent,
    LeftSidemenuComponent,
    WebKeyboardListenerComponent
  ],
  imports: [
    CommonModule,
    GameModule,
    IonicModule,
    SwiperModule,
    PipesModule,
    LastPlayedGamesModule,
    NgxPaginationModule,
    FooterModule,
    FormsModule,
    ReactiveFormsModule,
    MobileModule,
    directivesModule,
    DateETPipe,
    DateTimestampFormatPipe,
    DateFormatPipe,
    ThrottleClickDirective,
    ThrottleSubmitDirective
  ],
  exports: [
    AppInitComponent,
    BalanceComponent,
    BannerSliderComponent,
    BonusSelectorComponent,
    CalendarComponent,
    LoyaltyProgramPage,
    ContactSupportComponent,
    CustomNavbarComponent,
    DateTimePickerComponent,
    DepositAllMethodsComponent,
    DepositBonusOffersComponent,
    DepositButtonComponent,
    DepositDefaultAmountsComponent,
    DepositLimitComponent,
    DepositLogoComponent,
    ErrorMessageComponent,
    FooterModule,
    GamblingProblemComponent,
    GameAutomationComponent,
    InactivityComponent,
    InitGeoComply,
    LimitsTableRowComponent,
    MobileModule,
    NavigationTabsComponent,
    NoteBoxComponent,
    PipesModule,
    ProgressingComponent,
    RedirectComponent,
    ServerNotificationComponent,
    SidemenuComponent,
    LeftSidemenuComponent,
    SiteHeaderComponent,
    SiteLogoComponent,
    SizingComponent,
    SuccessMessageComponent,
    TransactionListComponent,
    ValidatePinComponent,
    WebcontentComponent,
    GamesBonusFreeSpinsComponent,
    HeaderTabsComponent,
    CDNIconComponent,
    SidemenuTabsComponent,
    WebKeyboardListenerComponent
  ],
  providers: [
    LoyaltyProgramProvider
  ]
})

export class ComponentsModule { }
